import useSWR from 'swr'
import ServiceAPI from '~services/services'

export const useFetchProviders = () => {
    const { data, mutate, error } = useSWR([`/providers`], () => ServiceAPI.getProviders());

    return {
        data,
        isLoading: !error && !data,
        isError: error,

        mutate,
    }
}

export default useFetchProviders
